/**
 * 打印相关参数 */
export default {
	state: {
		// 收款单详情展示
		printInfoObj: null,
		tkddyDetailsObj: null, // 退款单打印-详情
	},
	mutations: {
		setPrintInfoObj(state, payload) {
			state.printInfoObj = payload;
			if (window.localStorage) {
				window.localStorage.printInfoObj = JSON.stringify(state.printInfoObj);
			}
		},
		initPrintChargeInfoObj(state) {
			if (window.localStorage && window.localStorage.printInfoObj) {
				state.printInfoObj = JSON.parse(window.localStorage.printInfoObj);
			}
		},
		setTkddyDetailsObj(state, payload) {
			state.tkddyDetailsObj = payload;
			if (window.localStorage) {
				window.localStorage.tkddyDetailsObj = JSON.stringify(state.tkddyDetailsObj);
			}
		},
		initTkddyDetailsObj(state) {
			if (window.localStorage && window.localStorage.tkddyDetailsObj) {
				state.tkddyDetailsObj = JSON.parse(window.localStorage.tkddyDetailsObj);
			}
		},
	},
	getters: {},
};
